import React from 'react';
import Styles from './styles.module.sass';
import ReactDOM from 'react-dom';

function Modal({ ...props }) {
    const {
        children,
        onClose,
        type,
        title,
        cerrar,
        aceptar,
        periodos,
        setMostrarPeriodo
    } = props;

    // selecciona una opcion y cierra modal
    const handleSeleccion = (e) => {
        aceptar(e.target.id);
        cerrar();
    };

    // cerrar modal al hacer click fuera de el
    const cerrarM = () => {
        setMostrarPeriodo(false);
    };

    return (
        <div className={`modal ${type}`} onClick={cerrarM}>
            <div className={Styles?.contentModal} id="modalM">
                <div className={Styles?.contentCloseMovi}>
                    <div className={Styles?.btn} onClick={cerrar}>X</div>
                    {title ? <p className={Styles?.title}>{title}</p> : null}
                </div>

                <div className={Styles?.dataModal11}>
                    <ul className={Styles?.ulModal}>
                        {periodos && periodos.map((opc, i) =>
                            <li key={i} onClick={handleSeleccion} id={opc.periodo} name={opc.periodo}>{opc.periodo}</li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    )
}


export default function ModalMovimientos({ ...props }) {
    const {
        children,
        onClose,
        type,
        title,
        cerrar,
        aceptar,
        periodos, setMostrarPeriodo
    } = props;

    return ReactDOM.createPortal(
        <Modal onClose={onClose} type={type} title={title} cerrar={cerrar} aceptar={aceptar} periodos={periodos} setMostrarPeriodo={setMostrarPeriodo}>
            {children}
        </Modal>,
        document.getElementById('modal-root')
    )
}